import { render, staticRenderFns } from "./apply-supplier-multiplier-dialog.vue?vue&type=template&id=ddf01c4e&"
import script from "./apply-supplier-multiplier-dialog.vue?vue&type=script&lang=ts&"
export * from "./apply-supplier-multiplier-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddf01c4e')) {
      api.createRecord('ddf01c4e', component.options)
    } else {
      api.reload('ddf01c4e', component.options)
    }
    module.hot.accept("./apply-supplier-multiplier-dialog.vue?vue&type=template&id=ddf01c4e&", function () {
      api.rerender('ddf01c4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/products/components/apply-supplier-multiplier-dialog.vue"
export default component.exports